import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Globe } from "lucide-react";

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white/80 backdrop-blur-lg shadow-lg border-b border-gray-200/50 sticky top-0 z-50 transition-all duration-300">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="/logo.png"
              alt="ETB Tours Egypt"
              className="h-12 w-auto"
            />
            <div className="flex flex-col">
              <span className="text-xl font-bold text-teal-600">
                ETB Tours Egypt
              </span>
              <span className="text-xs text-red-600 font-medium">
                Since 1989
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              Egypt Tours
            </Link>
            <Link
              to="/"
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              Nile Cruises
            </Link>
            <Link
              to="/"
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              Day Tours
            </Link>
            <Link
              to="/"
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              Travel Guide
            </Link>
            <Link
              to="/"
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              Contact
            </Link>
          </nav>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center space-x-4">
            <button className="flex items-center space-x-1 text-gray-700 hover:text-teal-600 transition-colors">
              <Globe className="w-4 h-4" />
              <span>English</span>
            </button>
            <button className="flex items-center space-x-1 text-gray-700 hover:text-teal-600 transition-colors">
              <span>$ USD</span>
            </button>
            <button className="bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-700 transition-colors font-medium">
              Inquire
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
              >
                Egypt Tours
              </Link>
              <Link
                to="/"
                className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
              >
                Nile Cruises
              </Link>
              <Link
                to="/"
                className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
              >
                Day Tours
              </Link>
              <Link
                to="/"
                className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
              >
                Travel Guide
              </Link>
              <Link
                to="/"
                className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
              >
                Contact
              </Link>
              <div className="flex items-center space-x-4 pt-4 border-t border-gray-200">
                <button className="flex items-center space-x-1 text-gray-700">
                  <Globe className="w-4 h-4" />
                  <span>English</span>
                </button>
                <button className="flex items-center space-x-1 text-gray-700">
                  <span>$ USD</span>
                </button>
                <button className="bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-700 transition-colors font-medium">
                  Inquire
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
